export default "https://cdn.questicon.mathletics.com/assets/audio/selfAssesmentEmojis_5-9ecc1f1b8bf596efde464ef94c024280.mp3";